import moment from 'moment-timezone';
import * as Fetch from '../data/Fetch';
import * as utility from '../data/Utility';

const setAllPatientsType = 'SET_ALL_PATIENTS';
const setPatientType = 'SET_PATIENT';
const setPatientsFetchingType = 'SET_PATIENTS_FETCHING';

const initialState = {
    all: null,
    fetching: false,
    patient: null
};

export const emptyPatient = {
    clinicalId_Dynavision: null,
    code: "",
    dateOfBirth: null,
    enrollDateTime: null,
    procedureDate: null,
    withdrawalDateTime: null,
    studySiteId: ""
};

export const actionCreators = {
    create: (studySiteId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const patientsState = getState().patients;
        if (badState(accountsState, patientsState, true, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Patients/AddNew");
        const patient = patientsState.patient;
        const enrollDateTime = utility.getDateTimeJson(patient.enrollDateTime);
        const procedureDate = moment(patient.procedureDate).isValid() ? moment(patient.procedureDate).format("YYYY-MM-DD") : null;
        const withdrawalDateTime = moment(patient.withdrawalDateTime).isValid() ? moment(patient.withdrawalDateTime).format("YYYY-MM-DDTHH:mm:ss") : null;
        const body = JSON.stringify({
            code: patient.code && patient.code.trim(),
            enrollDateTime: enrollDateTime,
			procedureDate: procedureDate,
			withdrawalDateTime: withdrawalDateTime,
            studySiteId: studySiteId
        });
        await Fetch.postRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    get: (id) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const patientsState = getState().patients;
        if (badState(accountsState, patientsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Patients/GetById?id=${id}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setPatientType);
    },

    getAll: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const patientsState = getState().patients;
        if (badState(accountsState, patientsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Patients/GetAll");
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllPatientsType);
    },

    getAllByAuthenticatedUserStudy: (studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const patientsState = getState().patients;
        if (badState(accountsState, patientsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Patients/GetAllByAuthenticatedUserStudy?studyId=${studyId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllPatientsType);
    },

    getAllByStudy: (studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const patientsState = getState().patients;
        if (badState(accountsState, patientsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Patients/GetAllByStudy?studyId=${studyId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllPatientsType);
    },

    getAllByStudyAndSite: (studyId, siteId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const patientsState = getState().patients;
        if (badState(accountsState, patientsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Patients/GetAllByStudyAndSite?studyId=${studyId}&siteId=${siteId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllPatientsType);
    },

    set: (data) => async (dispatch) => {
        dispatch({ type: setPatientType, data });
    },

    update: (studySiteId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const patientsState = getState().patients;
        if (badState(accountsState, patientsState, true, dispatch)) {
            return;
        }

        const patient = patientsState.patient;
        const url = await Fetch.getUrl(`Patients/Update?id=${patient.id}`);
        const enrollDateTime = utility.getDateTimeJson(patient.enrollDateTime);
        const procedureDate = moment(patient.procedureDate).isValid() ? moment(patient.procedureDate).format("YYYY-MM-DD") : null;
        const withdrawalDateTime = moment(patient.withdrawalDateTime).isValid() ? moment(patient.withdrawalDateTime).format("YYYY-MM-DDTHH:mm:ss") : null;
        const body = JSON.stringify({
            code: patient.code && patient.code.trim(),
            enrollDateTime: enrollDateTime,
			procedureDate: procedureDate,
			withdrawalDateTime: withdrawalDateTime,
            studySiteId: studySiteId
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    }
};

function badState(accountsState, patientsState, checkPatient, dispatch) {
    if (accountsState == null ||
        patientsState == null ||
        patientsState.fetching) {
        return true;
    }
    if (checkPatient &&
        patientsState.patient == null) {
        return true;
    }

    setFetching(true, dispatch);
    return false;
}

function setFetching(data, dispatch) {
    dispatch({ type: setPatientsFetchingType, data });
}

function setResponse(data, dispatch, type) {
    Fetch.setResponse(data, dispatch, type, setPatientsFetchingType);
}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === setAllPatientsType) {
        return {
            ...state,
            all: action.data
        };
    }

    if (action.type === setPatientType) {
        return {
            ...state,
            patient: action.data
        };
    }

    if (action.type === setPatientsFetchingType) {
        return {
            ...state,
            fetching: action.data
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/Patients.js